// Finding a component by part or serial — shared by the record's Sub Components tab and the
// aircraft tab's Install sheet (moved out of ComponentSubComponents.tsx, 2026-10-07).

export type ComponentSearchBy = "number" | "serial";

/** The /v6/items params: part number/name go through `q` (it matches parts.name and
 * parts.number), a serial through an ilike filter. */
export function linkSearchParams(by: ComponentSearchBy, text: string) {
  const value = text.trim();
  if (by === "serial") {
    return {
      filter: [JSON.stringify({ field: "serial_number", op: "ilike", value: `%${value}%` })],
      size: 20,
    };
  }
  return { q: value, size: 20 };
}
